import { Component } from '@angular/core';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-a-welcome',
    templateUrl: './a-welcome.component.html',
    styleUrls: ['./a-welcome.component.scss'],
    standalone: false
})
export class AWelcomeComponent {

     isLoading = true;
     tag ='Loading';
     selectTranslator = 'base';

    constructor(public generalService: GeneralService) { }

    ngOnInit(): void {
        setTimeout(() => this.scrollToTop(), 500);
        this.isLoading = false;
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    openDocument(docName: string) {
        this.generalService.openDocument(docName);
    }
}
